import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } };

  connect() {
    // Slide in the toast
    setTimeout(() => {
      this.element.classList.remove("translate-x-full");
    }, 100);

    // Auto-dismiss after delay
    this.timeout = setTimeout(() => {
      this.dismiss();
    }, this.delayValue);
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  dismiss() {
    this.element.style.transition = "opacity 0.3s ease-out";
    this.element.style.opacity = "0";

    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove();
      }
    }, 300);
  }
}
